"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reportCustomerRecordCreate = reportCustomerRecordCreate;
exports.reportCustomerRecordDelete = reportCustomerRecordDelete;
exports.reportCustomerRecordUpdate = reportCustomerRecordUpdate;
var _adminOperationReport = require("@/utils/adminOperationReport");
var _reportContent = require("@/utils/reportContent");
/**
 * 【操作埋点】客户记录模块上报方法
 * 实施时间：2026-05-25
 * 说明：客服跟进记录新建/编辑/删除
 */

function buildRecordContent(recordInfo, action) {
  return (0, _reportContent.buildReportContent)(recordInfo, _reportContent.CUSTOMER_RECORD_LABELS, {
    prefix: action,
    formatters: {
      img_list: function img_list(val) {
        return Array.isArray(val) && val.length ? "\u5171".concat(val.length, "\u5F20") : '无';
      }
    }
  });
}

/**
 * 创建客户记录埋点上报
 */
function reportCustomerRecordCreate(recordInfo) {
  var meta = (0, _adminOperationReport.buildAdminOperationReportMeta)({
    operation_option: '新建客户记录',
    content: buildRecordContent(recordInfo, '新建客服跟进记录'),
    operation_id: 'pc_customer_record_create_1'
  });
  return (0, _adminOperationReport.reportAdminOperation)(meta, 'pc_customer_record_create_1');
}

/**
 * 更新客户记录埋点上报
 */
function reportCustomerRecordUpdate(recordId, recordInfo) {
  var meta = (0, _adminOperationReport.buildAdminOperationReportMeta)({
    operation_option: '编辑客户记录',
    content: buildRecordContent(recordInfo, "\u7F16\u8F91\u8BB0\u5F55ID ".concat(recordId)),
    operation_id: 'pc_customer_record_update_1'
  });
  return (0, _adminOperationReport.reportAdminOperation)(meta, 'pc_customer_record_update_1');
}

/**
 * 删除客户记录埋点上报
 */
function reportCustomerRecordDelete(recordId) {
  var recordInfo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var meta = (0, _adminOperationReport.buildAdminOperationReportMeta)({
    operation_option: '删除客户记录',
    content: (0, _reportContent.buildReportContent)(recordInfo, _reportContent.CUSTOMER_RECORD_LABELS, {
      prefix: "\u5220\u9664\u8BB0\u5F55ID ".concat(recordId)
    }),
    operation_id: 'pc_customer_record_delete_1'
  });
  return (0, _adminOperationReport.reportAdminOperation)(meta, 'pc_customer_record_delete_1');
}